function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import { translationUtils } from '@wix/photography-client-lib';

var FullscreenShareScreen = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenShareScreen, _React$Component);

  function FullscreenShareScreen() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenShareScreen.prototype;

  _proto.render = function render() {
    var _this = this;

    var shareButtons = /*#__PURE__*/React.createElement(FullscreenShareButtons, {
      item: this.props.current.item,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });

    var closeShareScreen = function closeShareScreen() {
      _this.props.actions.toggleShareScreen(false);
    };

    var shareTitleText = translationUtils ? translationUtils.getByKey('Gallery_Fullscreen_Mobile_Share') : 'Share';
    var showShareScreen = this.props.showShareScreen;
    return /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-share-screen' + (showShareScreen ? '' : ' pro-fullscreen-closed')
    }, /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-share-screen-background' + (showShareScreen ? '' : ' pro-fullscreen-closed'),
      onClick: showShareScreen ? closeShareScreen : null
    }), /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-share-screen-tab' + (showShareScreen ? '' : ' pro-fullscreen-closed')
    }, showShareScreen && /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-share-screen-tab-title'
    }, shareTitleText), showShareScreen && shareButtons));
  };

  return FullscreenShareScreen;
}(React.Component);

export default FullscreenShareScreen;